import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Tabs, BackTop } from 'antd';
import Dashboard from './Dashboard';
import DimensionAnalysis from '../DimensionAnalysis';
import moment from 'moment';

const { TabPane } = Tabs;

class PersonIndicatorAnalysis extends Component {
    static childContextTypes = {
        moduleType: PropTypes.string,
        activeKey: PropTypes.string,
        business: PropTypes.array,
        contractType: PropTypes.array,
        systemDate: PropTypes.object,
        area: PropTypes.object,
        handleExpand: PropTypes.func,
    }

    constructor(props) {
        super(props);
        this.panes = [{
            title: '资源利用率',
            key: 'financeIncome',
        }];
        this.state = {
            activeKey: 'financeIncome',
            moduleType: '',
            selectParams:{}
        };
    }

    getChildContext = () => {
        const { business, contractType, systemDate, area } = this.props;
        const { moduleType, activeKey } = this.state;
          // 中心收入分析 筛选需要过滤掉 ARO & 招募
        return {
            moduleType,
            activeKey,
            business,
            contractType,
            systemDate,
            area,
            handleExpand: this.handleExpand
        };
    }

    handleExpand = (moduleType, params) => {
        this.setState({ moduleType });
        if(params){
            params.year = moment((params&&(params.date || params.year)).toString()).format("YYYY");
            this.setState({ selectParams:{...params,date:null} });
        }    
    }

    handleTabsChange = (activeKey) => {
        this.setState({ activeKey });
    }

    getContent = (pane) => {
        const { activeKey } = this.state;
        if (pane.key === activeKey) {
            return (
                <Dashboard/>
            );
        } else {
            return null;
        }
    }

    render() {
        const { activeKey, moduleType, selectParams } = this.state;
        const{financeIndicatorAnalysis,projectIndicatorAnalysis}=this.props;
        return (
            <div className="tabWidth homePageTab" style={{ marginTop: -16 }}>
                {
                    !moduleType ?
                        <Tabs activeKey={activeKey} onChange={this.handleTabsChange}>
                            {this.panes.map(pane => <TabPane tab={pane.title} key={pane.key} disabled={pane.disabled}>{this.getContent(pane)}</TabPane>)}
                        </Tabs>
                    :
                        <DimensionAnalysis source="person" 
                        selectParams={selectParams}
                        personIndicatorAnalysis={true}
                        />
                }
                <BackTop />
            </div>
        );
    }
}

export default PersonIndicatorAnalysis;


// WEBPACK FOOTER //
// ./src/components/homePage/personIndicatorAnalysis/index.js